import { RG_TYPE } from "@project-rouge/rg-core";
import { queryPivot, getPivot } from "@project-rouge/rg-three";
import { Vector3, Line3 } from "three";
const closestPos = new Vector3();
const pointA = new Vector3();
const pointB = new Vector3();
const lineA = new Line3();
function getFirstDoorDistances(muscle) {
  const dists = [Infinity, Infinity];
  const muscleLine = toLine(muscle, lineA);
  if (muscle.gFUnits.length) {
    dists[0] = getClosestEntryDist({ start: true, muscleLine, gFUnits: muscle.gFUnits });
    dists[1] = getClosestEntryDist({ start: false, muscleLine, gFUnits: muscle.gFUnits });
  }
  const muscleB = muscle.bone.muscles.find((m) => m !== muscle);
  if (!muscleB || !muscleB.gFUnits.length)
    return dists;
  const gFUnits = muscleB.gFUnits.slice().reverse();
  const distsB = [
    getClosestEntryDist({ start: true, muscleLine, gFUnits }),
    getClosestEntryDist({ start: false, muscleLine, gFUnits })
  ];
  if (dists[0] === Infinity || dists[0] > distsB[0])
    dists[0] = distsB[0];
  if (dists[1] === Infinity || dists[1] > distsB[1])
    dists[1] = distsB[1];
  return dists;
}
function getClosestEntryDist({ start, muscleLine, gFUnits }) {
  const mPoint = start ? muscleLine.start : muscleLine.end;
  getClosestEntryPoint({ start, muscleLine, gFUnits, out: closestPos });
  return muscleLine.closestPointToPoint(closestPos, false, pointA).distanceTo(mPoint);
}
function getClosestEntryPoint({ start, muscleLine, out, gFUnits }) {
  const obj = gFUnits[start ? 0 : gFUnits.length - 1];
  const mPoint = start ? muscleLine.start : muscleLine.end;
  getEntrance(obj, [0, 0, 0], pointA);
  getEntrance(obj, [1, 0, 0], pointB);
  const closest = mPoint.distanceToSquared(pointA) < mPoint.distanceToSquared(pointB) ? pointA : pointB;
  return out.copy(closest);
}
function getEntrance(obj, pivot, out) {
  queryPivot({
    obj,
    pivot,
    type: RG_TYPE.Door,
    out,
    query: (d) => !!d.data.isEntrance
  });
  if (obj.type === RG_TYPE.Entrance && isNaN(out.x)) {
    getPivot([0.5, 0, 0], obj, out);
  }
  return out;
}
function toLine(obj, out) {
  out.start.fromArray(obj.points[0]);
  out.end.fromArray(obj.points[1]);
  return out;
}
export {
  getFirstDoorDistances
};
//# sourceMappingURL=index236.js.map
